/**
 * @generated SignedSource<<312885e46175f1caad2e8c88a205c3bc>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSpaceRoleMode = "PRE_ROLES" | "ROLES" | "ROLES_TRANSITION" | "%future added value";
export type useSpaceRoleModeQuery$variables = {
  cloudId: string;
};
export type useSpaceRoleModeQuery$data = {
  readonly confluence_spaceRoleMode: ConfluenceSpaceRoleMode | null | undefined;
};
export type useSpaceRoleModeQuery = {
  response: useSpaceRoleModeQuery$data;
  variables: useSpaceRoleModeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_spaceRoleMode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceRoleModeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceRoleModeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
    "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
    "metadata": {},
    "name": "useSpaceRoleModeQuery",
    "operationKind": "query",
    "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
  }
};
})();

(node as any).hash = "88c4ae8983cc6692099b2b1e1d7a4379";

export default node;
